module.exports = __webpack_public_path__ + "media/images/social/facebook-1e661af32cb823d5b0bb1b4602769257.png";